<template>
  <div id="on-boarding-contents-items"  class="w-full h-full flex justify-between justify-center p-4">

    <div v-if="pageImage[`${activeContents}_${activePageMap[activeContents]}`]"  class="h-full p-2 flex justify-center items-center" style="min-width: 50%;" :style="{ 'border-right': `2px solid ` + AISEA_COLOR.SLIGHTLY_GRAY , }">
      <img :src="pageImage[`${activeContents}_${activePageMap[activeContents]}`]" class="w-full" >
    </div>

    <div  class="w-full h-full px-6 pt-4 pb-2 flex justify-start items-start aisea-text-16-400-black" >

      <div :style="{ display: isSelectedPage(1,1) ? 'block' : 'none' ,}" >
        Aisea Crewをご利用いただきありがとうございます。<br />
        <br />
        Aisea Crewは、誰もが使いやすい船員向けのアプリと、充実機能の陸上管理者向けWebで、ストレスフリーな船員労務管理を実現するサービスです。本ガイドでは、サービスの概要をご説明致します。<br />
        <br />
        ※サービス概要の説明が不要な方は「<span class="cursor-pointer" :style="{ color: AISEA_COLOR.BLUE }" @click="setPage(2,1)">初期設定</span>」説明へお進みください。<br />
      </div>

      <div :style="{ display: isSelectedPage(1,2) ? 'block' : 'none' ,}" >
        船員はアプリで毎日打刻を行います。<br />
        打刻の登録はボタンを押すだけ。入力作業はございません。<br />
        オフラインに対応したアプリのため、船上が圏外でも登録することができます。<br />
      </div>

      <div :style="{ display: isSelectedPage(1,3) ? 'block' : 'none' ,}" >
        船長は、船員が申請した打刻記録を一覧で確認することができ、一括承認が可能です。また、打刻記録に不備がある場合、差戻しをすることもできます。<br />
      </div>

      <div :style="{ display: isSelectedPage(1,4) ? 'block' : 'none' ,}" >
        陸上管理者向けWebのダッシュボードでは、アラートを一覧表示します。<br />
        労務状況に注意が必要な船員を一目で確認できる他、船舶や役職ごとにアラート発生状況を確認することもできます。<br />
      </div>

      <div :style="{ display: isSelectedPage(1,5) ? 'block' : 'none' ,}" >
        船員からの打刻をもとに、労務管理記録簿が自動作成されます。<br />
        Webから最新状況をいつでも確認できる他、月ごとにExcelでの出力も可能なので、関係者への情報共有に便利です。<br />
        <br />
        <vs-button
          icon="arrow_forward"
          :color="AISEA_COLOR.BLUE"
          type="filled"
          style="margin: 0 0.6rem; height: 2.7rem;"
          @click="setPage(2,1)"
        ><span class="aisea-text-14-400-white">初期設定の方法へ進む</span></vs-button
        >
      </div>

      <div :style="{ display: isSelectedPage(2,1) ? 'block' : 'none' ,}" >
        さあ、早速Aisea Crewの利用を開始しましょう。<br />
        本ガイドでは、労務管理に必要となる以下の初期設定についてご説明致します。<br />
        <br />
        ・労務基本情報の登録<br />
        ・船舶の登録<br />
        ・陸上従業員のWebアカウント発行<br />
        ・船員の登録<br />
        ・労務情報の登録<br />
        ・乗船期間の登録<br />
        ・船員のアプリアカウント発行<br />
        <br />
        まずは、右上の「船員管理設定」メニューから「労務基本情報」をクリックしてください。<br />
      </div>

      <div :style="{ display: isSelectedPage(2,2) ? 'block' : 'none' ,}" >
        「労務基本情報」タブから、労務管理責任者や基準労働期間等、船員の労務管理に関する会社共通の情報を登録します。<br />
        「新規登録」ボタンをクリックし、情報を登録してください。<br />
        <br />
        保存した情報をデフォルトテンプレートとして登録すると、船員登録時に労務情報が自動入力されます。<br />
        <br />
        また、所属企業が異なる等で条件が異なる場合、テンプレートは複数作成することができます。<br />
      </div>

      <div :style="{ display: isSelectedPage(2,3) ? 'block' : 'none' ,}" >
        次に「船舶情報」タブから、船員が乗船する船舶を登録します。<br />
        「新規登録」をクリックし、船舶情報を登録してください。<br />
      </div>

      <div :style="{ display: isSelectedPage(2,4) ? 'block' : 'none' ,}" >
        「陸上従業員一覧」のタブから、陸上管理者向けのWebアカウントを発行します。<br />
        <br />
        「招待」をクリックし、陸上従業員のメールアドレスを登録すると、アカウント発行用のURLが送信されます。<br />
        <br />
        他の陸上従業員に初期設定を依頼する場合には、先に陸上従業員の招待を行うことも可能です。<br />
      </div>

      <div :style="{ display: isSelectedPage(2,5) ? 'block' : 'none' ,}" >
        「船員一覧」タブから、労務管理を行う船員を登録します。<br />
        「新規登録」をクリックし、船員の情報を登録してください。「続けて登録する」をチェックすることで、一度に複数の船員の登録を行うことが可能です。<br />
        <br />
        ※船員向けアプリのアカウントを発行するためにはメールアドレスが必要となります。事前に各船員のメールアドレスをご確認下さい。<br />
      </div>

      <div :style="{ display: isSelectedPage(2,6) ? 'block' : 'none' ,}" >
        船員登録完了後、船員一覧から任意の船員の行をクリックすると、各船員ページへ遷移し、詳細情報を確認することができます。<br />
        <br />
        次ページから、各船員の詳細情報の入力についてご案内致します。<br />
      </div>

      <div :style="{ display: isSelectedPage(2,7) ? 'block' : 'none' ,}" >
        「労務情報」タブから、船員個人に適用される労務情報を登録します。（「労務基本情報」と同じ項目です。）<br />
        <br />
        「労務基本情報」として登録したテンプレートが適用されている場合、有給休暇の日数等、船員ごとに異なる情報の修正を行ってください。<br />
      </div>

      <div :style="{ display: isSelectedPage(2,8) ? 'block' : 'none' ,}" >
        「乗船期間」タブから、各船員の乗船先船舶、乗船期間等を登録します。<br />
        「新規登録」をクリックし、情報を登録してください。<br />
        <br />
        「承認権限」の項目では、船員向けアプリの打刻記録の承認権限の付与を行うことができます。「船長」には必ず付与され、「一等航海士」および「機関長」には任意で付与することができます。<br />
        <br />
        ※乗船期間は後から修正することができるため、登録時は未確定情報でも構いません。<br />
      </div>

      <div :style="{ display: isSelectedPage(2,9) ? 'block' : 'none' ,}" >
        「船員基本情報」タブから、船員のアプリアカウントを発行します。<br />
        「アプリアカウント発行」をクリックし、任意のパスワードを設定してください。<br />
        <br />
        アカウント発行後、アプリのダウンロード方法を記載したマニュアルとともに、以下のログイン情報を個別に船員に案内してください。<br />
        <br />
        <span class="aisea-text-16-600-black">
        【ログイン情報】<br />
        ・法人ID（会社共通）<br />
        ・ユーザーID（登録いただいたメールアドレス）<br />
        ・パスワード（設定いただいたパスワード）<br />
        </span>
        <br />
        <vs-button
          icon="arrow_forward"
          :color="AISEA_COLOR.BLUE"
          type="filled"
          style="margin: 0 0.6rem; height: 2.7rem;"
          @click="setPage(3,1)"
        ><span class="aisea-text-14-400-white">運用時の利用方法へ進む</span></vs-button
        >
      </div>

      <div :style="{ display: isSelectedPage(3,1) ? 'block' : 'none' ,}" >
        初期設定が完了し、船員にアプリの利用方法をご理解いただいたら、いよいよAisea Crewの運用開始です。<br />
        <br />
        本ガイドでは、陸上管理者の皆様が日々利用される画面の説明を行います。<br />
      </div>

      <div :style="{ display: isSelectedPage(3,2) ? 'block' : 'none' ,}" >
        「労務ダッシュボード」画面では、船員の過労アラート発生状況を一覧で確認することができます。<br />
        <br />
        陸上管理者は、毎日本画面を確認することで、船員の過労リスク発生有無をすぐに把握し、速やかな過労防止措置に繋げることができます。<br />
        <br />
        また、気になった船員の行をクリックすることで、各船員の詳細情報を確認することができます。<br />
      </div>

      <div :style="{ display: isSelectedPage(3,3) ? 'block' : 'none' ,}" >
        「勤怠情報」タブでは、各船員の打刻記録に基づきリアルタイムで労務管理記録簿が作成されていきます。<br />
        <br />
        以下の3つのアラートが実装されております。<br />
        ・過去24時間以内の労働時間規制<br />
        ・過去7日間いないの労働時間規制<br />
        ・休息時間規制<br />
        <br />
        また、各船員の休日情報も本画面で登録することが可能です。<br />
      </div>

      <div :style="{ display: isSelectedPage(3,4) ? 'block' : 'none' ,}" >
        「打刻記録」タブでは、船員がアプリで登録した打刻記録を確認することができます。<br />
        <br />
        陸上管理者は、各船員の打刻状況を確認できるとともに、不備があった場合には打刻記録の差戻しを行うことができます。<br />
      </div>

      <div :style="{ display: isSelectedPage(3,5) ? 'block' : 'none' ,}" >
        「乗船期間」タブでは、各船員の入替スケジュールに合わせて乗船期間の情報を新規登録・更新することができます。<br />
        <br />
        乗船期間の情報が正しく入力されていない場合、労務管理記録簿が正しく作成されない他、船員向けアプリで船長と船員の紐付けが正しく行われないためご注意下さい。<br />
        <br />
        <vs-button
          icon="arrow_forward"
          :color="AISEA_COLOR.BLUE"
          type="filled"
          style="margin: 0 0.6rem; height: 2.7rem;"
          @click="setPage(4,1)"
        ><span class="aisea-text-14-400-white">詳細マニュアルへ進む</span></vs-button
        >
      </div>

      <div :style="{ display: isSelectedPage(4,1) ? 'block' : 'none' ,}" class="flex w-full h-full justify-center items-center px-10">
        <div class="flex justify-center items-center flex-direction--column" style="margin: 0 15%;">
          <div class="flex w-full justify-center items-center" >
            詳細の利用方法は各種マニュアルページにてご確認ください。
          </div>
          <vs-divider class="my-10" />
          <div class="flex w-full justify-between items-center px-10">
            <div class="aisea-text-16-600-black">AiseaCrew労務管理ウェブ版</div>
            <vs-button
              class="flex justify-end"
              type="filled"
              icon="menu_book"
              :color="AISEA_COLOR.BLUE"
              @click.stop="openWebManual()"
              ><span class="aisea-text-14-400-white">マニュアルページへ</span></vs-button
            >
          </div>
          <vs-divider class="my-6" />
          <div class="flex w-full justify-between items-center px-10">
            <div class="aisea-text-16-600-black">Aisea Crew船員向けアプリ版</div>
            <vs-button
              class="flex justify-end"
              type="filled"
              icon="menu_book"
              :color="AISEA_COLOR.BLUE"
              @click.stop="openAppManual()"
              ><span class="aisea-text-14-400-white">マニュアルページへ</span></vs-button
            >
          </div>
          <vs-divider class="my-6" />
          <div class="flex w-full justify-center items-center mt-6" >
            <vs-button
              icon="arrow_forward"
              :color="AISEA_COLOR.BLUE"
              type="filled"
              style="margin: 0 0.6rem; height: 2.7rem;"
              @click="setPage(1,1)"
            ><span class="aisea-text-14-400-white">サービス概要に戻る</span></vs-button
            >
          </div>
        </div>

      </div>



    </div>

  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  name: "OnboardingContentsItems",
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    activeContents: { type: Number },
    activePageMap: { type: Object },
  },
  data() {
    return {
      urlAppManual: 'https://crew.aisea.net/app_manual.pdf',
      urlWebManual: 'https://crew.aisea.net/web_manual.pdf',
      pageImage: {
        '1_1': require("@/assets/images/crew-management/onboarding/page_image_1_1.svg"),
        '1_2': require("@/assets/images/crew-management/onboarding/page_image_1_2.svg"),
        '1_3': require("@/assets/images/crew-management/onboarding/page_image_1_3.svg"),
        '1_4': require("@/assets/images/crew-management/onboarding/page_image_1_4.svg"),
        '1_5': require("@/assets/images/crew-management/onboarding/page_image_1_5.svg"),
        '2_1': require("@/assets/images/crew-management/onboarding/page_image_2_1.svg"),
        '2_2': require("@/assets/images/crew-management/onboarding/page_image_2_2.svg"),
        '2_3': require("@/assets/images/crew-management/onboarding/page_image_2_3.svg"),
        '2_4': require("@/assets/images/crew-management/onboarding/page_image_2_4.svg"),
        '2_5': require("@/assets/images/crew-management/onboarding/page_image_2_5.svg"),
        '2_6': require("@/assets/images/crew-management/onboarding/page_image_2_6.svg"),
        '2_7': require("@/assets/images/crew-management/onboarding/page_image_2_7.svg"),
        '2_8': require("@/assets/images/crew-management/onboarding/page_image_2_8.svg"),
        '2_9': require("@/assets/images/crew-management/onboarding/page_image_2_9.svg"),
        '3_1': require("@/assets/images/crew-management/onboarding/page_image_3_1.svg"),
        '3_2': require("@/assets/images/crew-management/onboarding/page_image_3_2.svg"),
        '3_3': require("@/assets/images/crew-management/onboarding/page_image_3_3.svg"),
        '3_4': require("@/assets/images/crew-management/onboarding/page_image_3_4.svg"),
        '3_5': require("@/assets/images/crew-management/onboarding/page_image_3_5.svg"),
      }
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    isSelectedPage(contentsNum, pageNum) {
      return this.activeContents === contentsNum && this.activePageMap[this.activeContents] === pageNum;
    },
    setPage(contentsNum, pageNum) {
      this.$emit('setPage', {contentsNum: contentsNum, pageNum: pageNum, });
    },
    openAppManual() {
      window.open(this.urlAppManual, '_blank');

    },
    openWebManual() {
      window.open(this.urlWebManual, '_blank');
    },
  },  
};
</script>


<style lang="scss">
@import "src/assets/scss/aisea/variables";

#on-boarding-contents-items {

}
</style>
